import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddSignals from "../AddSignals";

const AddSignalsDialog = ({ open, onClose, refresh, users }) => {
  const handleRefresh = () => {
    if (refresh) refresh();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddSignals refresh={handleRefresh} users={users} />
      </Box>
    </Dialog>
  );
};

export default AddSignalsDialog;
